import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { MenuItem, Typography } from "@mui/material"
import { EAN_LENGTH, MAX_EMAIL_LENGTH } from "../../../../../../constants/inputValidationDefaults"
import { FormikDropdown, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { EntityFormValues, InvoiceType } from "../../supportEntitiesTypes"

const useStyles = makeStyles()(() => ({
    textField: {
        width: "50%",
    },
}))

export function InvoiceDetailsContent({ isUpdateSupplier = false }) {
    const { classes } = useStyles()

    const { values } = useFormikContext<EntityFormValues>()

    return (
        <>
            <LocalizedStrict id="support-create-entity-invoice-details-subtitle">
                <Typography mb="0.5rem" fontWeight={400}>
                    Invoice details
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-send-invoice-to-label" attrs={{ label: true }}>
                <FormikDropdown<EntityFormValues> fullWidth label="Send invoice to" name="invoiceType">
                    <MenuItem value={InvoiceType.EAN_NUMBER}>
                        <LocalizedStrict id="support-create-entity-dropdown-ean-number">
                            <span>EAN number</span>
                        </LocalizedStrict>
                    </MenuItem>
                    <MenuItem value={InvoiceType.EMAIL}>
                        <LocalizedStrict id="support-create-entity-dropdown-email">
                            <span>Email</span>
                        </LocalizedStrict>
                    </MenuItem>
                </FormikDropdown>
            </LocalizedStrict>
            {values.invoiceType && (
                <>
                    {!isUpdateSupplier && (
                        <LocalizedStrict
                            id="support-create-entity-debitor-number-label"
                            attrs={{ label: true, helperText: true }}
                        >
                            <FormikTextField<EntityFormValues>
                                className={classes.textField}
                                name="debitorNo"
                                label="Debitor Number"
                                helperText="This identifies the debtor in FacilityNet accounting system."
                            />
                        </LocalizedStrict>
                    )}
                    {values.invoiceType === InvoiceType.EMAIL && (
                        <LocalizedStrict id="support-create-entity-invoice-email-label" attrs={{ label: true }}>
                            <FormikTextField<EntityFormValues>
                                className={classes.textField}
                                name="invoiceEmail"
                                label="Email"
                                inputProps={{
                                    maxLength: MAX_EMAIL_LENGTH,
                                }}
                            />
                        </LocalizedStrict>
                    )}

                    {values.invoiceType === InvoiceType.EAN_NUMBER && (
                        <LocalizedStrict id="support-create-entity-ean-number-label" attrs={{ label: true }}>
                            <FormikTextField<EntityFormValues>
                                className={classes.textField}
                                name="eanNumber"
                                label="EAN number"
                                inputProps={{
                                    maxLength: EAN_LENGTH,
                                }}
                            />
                        </LocalizedStrict>
                    )}
                    <LocalizedStrict id="support-create-entity-attention-label" attrs={{ label: true }}>
                        <FormikTextField<EntityFormValues>
                            className={classes.textField}
                            name="attention"
                            label="Attention"
                        />
                    </LocalizedStrict>
                    <LocalizedStrict id="support-create-entity-reminder-email-label" attrs={{ label: true }}>
                        <FormikTextField<EntityFormValues>
                            className={classes.textField}
                            name="reminderEmail"
                            label="Email for reminders / account statements"
                            inputProps={{
                                maxLength: MAX_EMAIL_LENGTH,
                            }}
                        />
                    </LocalizedStrict>
                    <LocalizedStrict id="support-create-entity-po-number-label" attrs={{ label: true }}>
                        <FormikTextField<EntityFormValues>
                            className={classes.textField}
                            name="poNumber"
                            label="Purchase order number"
                        />
                    </LocalizedStrict>
                </>
            )}
        </>
    )
}
